import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * @deprecated
 * Use DropdownMenu.
 */
class Dropdown extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
    xpos: PropTypes.oneOf(['left', 'right']),
    toggle: PropTypes.node,
    toggleLabel: PropTypes.string,
    toggleStyle: PropTypes.oneOf([
      'primary',
      'secondary',
      'success',
      'info',
      'warning',
      'danger',
      'link',
    ]),
    toggleClassName: PropTypes.string,
    dropdownClassName: PropTypes.string,
    startOpen: PropTypes.bool,
  };

  static defaultProps = {
    xpos: 'left',
    toggleStyle: 'secondary',
  };

  state = {
    open: !!this.props.startOpen,
  };

  componentDidMount() {
    const { open } = this.state;

    if (open) {
      document.addEventListener('click', this.onClickOutside, false);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.onClickOutside, false);
  }

  onDropdownToggle = event => {
    if (event) {
      event.preventDefault();
    }

    const { open } = this.state;

    // Close the dropdown if we click outside of it
    if (!open) {
      document.addEventListener('click', this.onClickOutside, false);
    } else {
      document.removeEventListener('click', this.onClickOutside, false);
    }

    this.setState(state => ({
      open: !state.open,
    }));
  };

  onClickOutside = event => {
    if (this.node && this.node.contains(event.target)) {
      return;
    }

    this.onDropdownToggle(event);
  };

  render() {
    const { open } = this.state;

    const {
      className,
      xpos,
      toggle,
      toggleLabel,
      toggleStyle,
      toggleClassName,
      dropdownClassName,
      children,
    } = this.props;

    const classes = classNames({
      dropdown: true,
      'dropdown-right': xpos === 'right',
      [className]: !!className,
    });

    const toggleClasses = classNames({
      btn: !toggle,
      'dropdown-toggle': !toggle,
      [`btn-${toggleStyle}`]: !!toggleStyle && !toggle,
      [toggleClassName]: !!toggleClassName,
    });

    const dropdownClasses = classNames({
      'dropdown-menu': true,
      [dropdownClassName]: !!dropdownClassName,
    });

    return (
      <div
        className={classes}
        ref={node => {
          this.node = node;
        }}
      >
        <a
          onClick={this.onDropdownToggle}
          className={toggleClasses}
          href="#dropdown"
          role="button"
        >
          {toggle || toggleLabel}
        </a>

        {open && <div className={dropdownClasses}>{children}</div>}
      </div>
    );
  }
}

export default Dropdown;
